import React from 'react'
import { Modal } from '../../../UI/Modal'

interface CompanyModalProps {
  show: boolean
  onHide: () => void
  companyName?: string
  modalTitle: string
  children: React.ReactNode
  size?: 'sm' | 'lg' | 'xl'
}

export function CompanyModal({
  show,
  onHide,
  companyName,
  modalTitle,
  children,
  size = 'xl',
}: CompanyModalProps) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      centered
      enforceFocus={false}
      backdrop="static"
    >
      <button
        type="button"
        className="btn-close absolute top-5 right-[30px] z-10"
        aria-label="Close"
        onClick={onHide}
      />
      <Modal.Header className="px-[32px] py-[20px] border-0">
        <div className="flex flex-col gap-1 w-full">
          {companyName && (
            <div className="text-[11px] font-light uppercase tracking-[0.03em] leading-[28px] align-middle text-[#6E6E6E]">
              {companyName}
            </div>
          )}
          <Modal.Title className="text-2xl font-normal leading-[1.2] tracking-[0em] align-middle text-[#101828] m-0">
            {modalTitle}
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body className="pt-0">{children}</Modal.Body>
    </Modal>
  )
}
